// extracted by mini-css-extract-plugin
export default {"basicButton":"ButtonBasic_basicButton__K0hMU","smallButton":"ButtonBasic_smallButton__mlsuK","largeButton":"ButtonBasic_largeButton__7FKIS"};